/**
 * Shared Auth Context - used by both standalone and federated providers.
 *
 * This module contains only the shared context and types, with no MSAL dependencies.
 * Both AuthProvider (standalone) and FederatedAuthProvider use this same context,
 * ensuring that useAuth() works regardless of which provider is used.
 */
import { createContext, useContext } from 'react';
/**
 * The shared auth context - used by both AuthProvider and FederatedAuthProvider.
 */
export const AuthContext = createContext(null);
/**
 * Hook to use auth context.
 * @throws Error if used outside AuthProvider or FederatedAuthProvider
 */
export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider or FederatedAuthProvider');
    }
    return context;
}
/**
 * Hook to optionally use auth context.
 * Returns null if used outside AuthProvider (doesn't throw).
 */
export function useAuthOptional() {
    return useContext(AuthContext);
}
//# sourceMappingURL=shared-context.js.map